import { useState, useCallback } from 'react';

/**
 * Config [Config] Retornos por condição de intervenção = 01 → exibe abas Pendente/Liberado no Board.
 */
export function useFuturaRetornoTabsEnabled(apiBaseUrl) {
  const [futuraRetornoTabsEnabled, setFuturaRetornoTabsEnabled] = useState(false);

  const loadFuturaRetornoTabsConfig = useCallback(async () => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        setFuturaRetornoTabsEnabled(false);
        return;
      }
      const response = await fetch(`${apiBaseUrl}/api/config/retornos-condicao-intervencao`, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
      });
      if (response.status === 401) {
        setFuturaRetornoTabsEnabled(false);
        return;
      }
      const result = await response.json();
      const on = result.success && result.data && String(result.data.codstatus || '').trim() === '01';
      setFuturaRetornoTabsEnabled(!!on);
    } catch {
      setFuturaRetornoTabsEnabled(false);
    }
  }, [apiBaseUrl]);

  const resetFuturaRetornoTabsEnabled = useCallback(() => {
    setFuturaRetornoTabsEnabled(false);
  }, []);

  return {
    futuraRetornoTabsEnabled,
    setFuturaRetornoTabsEnabled,
    loadFuturaRetornoTabsConfig,
    resetFuturaRetornoTabsEnabled
  };
}
